const { isAuthorized } = require('@smarttransit/common')
const { isOnlyInvestor } = require('./is-only-investor')

const TICKET_REVENUE_REPORT_TYPE = 'ticket_revenue'

function reportTypeValue (item) {
  if (!item) {
    return null
  }
  if (typeof item === 'string') {
    return item
  }
  return item.reportType || item.value || null
}

function isTransportationOwnerUser (user) {
  return !!(user && isAuthorized(user, 'transporter') && !isAuthorized(user, 'staffIncludingInvestor'))
}

function canViewTransportationOwnerTicketRevenue (user) {
  if (!user) {
    return false
  }
  if (isAuthorized(user, 'superadmin')) {
    return true
  }
  if (isOnlyInvestor(user)) {
    return true
  }
  return isTransportationOwnerUser(user)
}

function filterTicketRevenueReportTypes (reportTypes, user) {
  const types = Array.isArray(reportTypes) ? reportTypes : []
  if (canViewTransportationOwnerTicketRevenue(user)) {
    return types.slice()
  }
  return types.filter(function (item) {
    return reportTypeValue(item) !== TICKET_REVENUE_REPORT_TYPE
  })
}

function resolveVisibleReportType (preferredType, reportTypes, user) {
  const canViewTicketRevenue = canViewTransportationOwnerTicketRevenue(user)
  const available = filterTicketRevenueReportTypes(reportTypes, user)
    .map(reportTypeValue)
    .filter(function (value) { return !!value })

  if (!available.length) {
    if (!canViewTicketRevenue && preferredType === TICKET_REVENUE_REPORT_TYPE) {
      return null
    }
    return preferredType || null
  }

  if (preferredType && available.indexOf(preferredType) !== -1) {
    return preferredType
  }

  if (available.indexOf(TICKET_REVENUE_REPORT_TYPE) !== -1) {
    return TICKET_REVENUE_REPORT_TYPE
  }

  return available[0]
}

module.exports = {
  TICKET_REVENUE_REPORT_TYPE,
  isTransportationOwnerUser,
  canViewTransportationOwnerTicketRevenue,
  filterTicketRevenueReportTypes,
  resolveVisibleReportType
}
